import React from "react"
import Chip from "../atoms/misc/Chip.atom"
import Tooltip from "../atoms/Tooltip.atom"
import { Skeleton } from "../atoms/misc/Skeleton.atom"
import { generateRandomId } from "../../utils/strings.utils"
import { CLIENT_REPORT_STATUSES } from "../../consts/modules/clientReport.consts"

const StatusChip = ({
  status,
  tooltip,
  tooltipContent,
  tooltipConfig,
  availableStatuses = CLIENT_REPORT_STATUSES,
  loading = false,
}) => {
  const statusData = availableStatuses.find((s) => s.name === status)
  if (!statusData) {
    return null
  }
  if (loading) {
    return (
      <Skeleton
        className="status-chip-skeleton border-round-sm"
        width={"5rem"}
        height={"18px"}
      />
    )
  }
  const chipClassName = `status-chip-${generateRandomId()}`
  return (
    <>
      <Chip
        className={`status-chip ${chipClassName} text-white`}
        style={{ backgroundColor: `${statusData.color}`, height: "18px" }}
        template={
          <>
            <span style={{ fontSize: "12px" }}>{statusData.label}</span>
          </>
        }
      />
      {tooltip && (
        <Tooltip target={`.${chipClassName}`} {...tooltipConfig}>
          {tooltipContent}
        </Tooltip>
      )}
    </>
  )
}

export default StatusChip
